import * as React from 'react';
import { useTranslation } from 'react-i18next';

export type DisclaimerPhoneValidationProps = {
  className?: string;
};

export const DisclaimerPhoneValidation = ({ className }: DisclaimerPhoneValidationProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={`max-w-6xl p-8 mt-5 bg-yellow-100 text-yellow-900 border border-yellow-200 m-auto ${className}`}
    >
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText1')}</p>
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText2')}</p>
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText3')}</p>
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText4')}</p>
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText5')}</p>
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText6')}</p>
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText7')}</p>
      <p className="font-black">{t('DisclaimerPhoneValidation.claimText8')}</p>
    </div>
  );
};
